module.exports = "<p>calendar works!</p>\n"